<template>
    <div>
      <van-nav-bar 
      :title='title'
      left-arrow
      right-text="首页"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      />
    </div>
</template>

<script>
export default {
  props:['title'],
  data(){
    return{
    }
  },
  mounted(){
  },
  methods: {
    onClickLeft () {
        this.$router.go(-1)
    },
    onClickRight () {
        this.$router.push('/')
    }
  }
}
</script>

<style>
.van-nav-bar__text{
  font-size: 17px;
    color: #1989fa !important;
}
.van-nav-bar .van-icon{
    font-size: 20px;
    color:  #1989fa !important;
}
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NavBarlogin.vue